import { render, staticRenderFns } from "./tx-market-badge.vue?vue&type=template&id=6acbf1ff&scoped=true"
import script from "./tx-market-badge.vue?vue&type=script&lang=js"
export * from "./tx-market-badge.vue?vue&type=script&lang=js"
import style0 from "./tx-market-badge.vue?vue&type=style&index=0&id=6acbf1ff&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acbf1ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6acbf1ff')) {
      api.createRecord('6acbf1ff', component.options)
    } else {
      api.reload('6acbf1ff', component.options)
    }
    module.hot.accept("./tx-market-badge.vue?vue&type=template&id=6acbf1ff&scoped=true", function () {
      api.rerender('6acbf1ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tai-xiu/tx-market-badge.vue"
export default component.exports